import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { IssueReportNote } from '../../../globals/interfaces';
import { formatDatetime } from '../../../utils';

interface Props {
    item: IssueReportNote | undefined;
    modal: boolean;
    setModal: (state: boolean) => void;
}

export default function NotesModal ({
    item,
    modal,
    setModal
}: Props) {

    const toggle = () => setModal(!modal);

    if (!item) return null;

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>View Note</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <h6>{item.note} by {item.createdBy} at {formatDatetime(item.createdAt)}</h6>
            </ModalBody>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;